/* eslint-disable @typescript-eslint/no-explicit-any */
import { Reducer } from 'redux';
import liveSessionCardSlice, { LIVE_SESSION_CARD_KEY_IN_STORE } from './slice';
import { liveSessionCardSaga } from './sagas';

export class LiveSessionCardModule {
	getRootKeyInStore(): string {
		return LIVE_SESSION_CARD_KEY_IN_STORE;
	}

	getReducers(): Reducer {
		return liveSessionCardSlice.reducer;
	}

	getSagas(): () => Generator<any, void, any> {
		return liveSessionCardSaga;
	}
}

export const moduleInstance = new LiveSessionCardModule();
